import React, { useState } from 'react';
import { Row, Col, Button, Form } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { useInject } from '../common';
import { logLead } from '../API/GHL';
import { useCustomer, useCustomerDispatch } from '../common/customerContext';
import CustomerForm from '../Components/customerForm';
import ProgressHeader from '../Components/Styled/ProgressHeader';
import { CUSTOMER_ACTIONS, PAGES } from '../constants';
import useCustomerNavigation from '../Hooks/NavigationHook';
import { PriceItem } from '../common/PriceItem';
export const Contact = () => {
  const [form] = useForm();
  const { selfSignupCustomerService, servicesService } = useInject();
  const dispatch = useCustomerDispatch();
  const customerNavigation = useCustomerNavigation();
  const [isLoading, setIsLoading] = useState(false);
  const customer = useCustomer();
  const loadServices = async () => {
    setIsLoading(true);
    const data = await servicesService.getServices(customer.marketId, customer);
    const newServices = data.filter(
      (x) => !customer?.services?.map((s) => s.serviceId)?.includes(x.serviceId)
    );
    customerNavigation(
      PAGES.SERVICES,
      CUSTOMER_ACTIONS.SERVICES,
      [
        ...(customer?.services?.map((service) => {
          service.tshirtSize = customer?.tshirtSize;
          return PriceItem.mergeSavedService(service);
        }) || []),
        ...newServices,
      ],
      () => {
        if (customer?.meetCode?.length > 1) {
          return PAGES.MEET_CUSTOMER_DETAILS;
        }
      }
    );
    delete customer.propertySizeChangedCount;
    await selfSignupCustomerService.saveCustomerProgress(customer);
    setIsLoading(false);
  };
  const submitForm = async () => {
    try {
      const prevFormState = customer.formFilled;
      await form.validateFields();
      customer.formFilled = true;
      await selfSignupCustomerService.saveCustomerProgress(customer);
      if (!prevFormState && process.env.REACT_APP_STAGE === 'prod') {
        await logLead({
          firstName: customer.firstName,
          lastName: customer.lastName,
          emailAddress: customer.emailAddress,
          phoneNumber: customer.phoneNumber,
          ...(customer.address ?? {}),
        });
      }

      dispatch(CUSTOMER_ACTIONS.LEADGEN, customer);
      await loadServices();
    } catch (errInfo) {
      console.log('Validate Failed:', errInfo);
    }
  };
  return (
    <div style={{ backgroundColor: '#F7F6F2', height: '100vh' }}>
      <Row type="flex" justify="center" style={{}}>
        <ProgressHeader
          completionPercentage={40}
          showBackIcon={true}
          hasNav={true}
          title={'Who are we personalizing this plan for?'}
        />

        <Col
          align="center"
          xs={24}
          md={14}
          lg={12}
          style={{ marginTop: '8px' }}
          className="padMobile"
        >
          <span style={{ marginTop: 8, textAlign: 'center' }}>
            Enter your details below to begin
          </span>
          <Form
            autoComplete="on"
            form={form}
            layout="vertical"
            onFinish={submitForm}
            initialValues={{
              firstName: customer.firstName,
              lastName: customer.lastName,
              emailAddress: customer.emailAddress,
              phoneNumber: customer.phoneNumber,
            }}
          >
            <div style={{ marginTop: '24px' }} />
            <CustomerForm action={CUSTOMER_ACTIONS.LEADGEN} />
            <Form.Item>
              <div style={{ textAlign: 'center' }}>
                <Button
                  className="main-button"
                  style={{ marginBottom: '48px', marginTop: '32px' }}
                  type="primary"
                  htmlType="submit"
                  loading={isLoading}
                  // disabled={!submittable}
                >
                  Next
                </Button>
              </div>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </div>
  );
};
